export default function verifyToken(token) {
const verifyToken=localStorage.getItem('_xt_cfg_9x2kgd$25gT57') ? localStorage.getItem('_xt_cfg_9x2kgd$25gT57') : null


if (!token|| !verifyToken) {
return false;
}
return token === verifyToken?true:false;

}